import { render, staticRenderFns } from "./GameTimer.vue?vue&type=template&id=970dfb06&scoped=true"
import script from "./GameTimer.vue?vue&type=script&lang=js"
export * from "./GameTimer.vue?vue&type=script&lang=js"
import style0 from "./GameTimer.vue?vue&type=style&index=0&id=970dfb06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "970dfb06",
  null
  
)

export default component.exports